import { withAsyncLoading } from '../../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListCompagnonPage = withAsyncLoading(async () =>
    import('./ListCompagnonPage').then((res) => res.ListCompagnonPage)
);

export { LoadableListCompagnonPage };
